import styled, { css } from 'styled-components'
import { Text } from '@sketch/components'
import { ReactComponent as CommentsIcon } from '@sketch/icons/comments-64'

export const PreviewContainer = styled.div(
  ({ theme }) => css`
    width: 68px;
    height: 68px;
    border-radius: ${theme.radii.large};
    border: 1px solid ${theme.colors.border.A};
    background-color: ${theme.colors.background.tertiary.D};
    padding: 4px;
    display: grid;
    grid-template-columns: repeat(2, 28px);
    grid-gap: 4px;
  `
)

export const PreviewImage = styled.img(
  ({ theme }) => css`
    width: 28px;
    height: 28px;
    border-radius: ${theme.radii.base};
    border: 1px solid ${theme.colors.border.A};
    background-color: ${theme.colors.background.secondary.A};
  `
)

export const Title = styled(Text).attrs({ textStyle: 'header.primary.G' })`
  padding-bottom: 4px !important; /* stylelint-disable-line declaration-no-important */
`

export const EmptyTextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 208px;
  text-align: center;

  p:first-of-type {
    padding-bottom: 4px !important; /* stylelint-disable-line declaration-no-important */
  }
`

export const CommentsIconStyled = styled(CommentsIcon)`
  opacity: 0.3;
`
